import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-processing',
  templateUrl: './payment-processing.component.html',
  styleUrls: ['./payment-processing.component.scss'],
})
export class PaymentProcessingComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
